import Authentication from './Authentication';
import ForgotPassword from './components/ForgotPassword';
import NewPassRequired from './components/NewPassRequired';
import ResetPassword from './components/ResetPassword';
import SignIn from './components/SignIn';

export default Authentication;
export { ForgotPassword, NewPassRequired, ResetPassword, SignIn };
